import { useCallback } from 'react';
import { useOpenDeeplink } from '../../../../hooks';
import { appendParams, buildUrl, finalizeUrl } from '../../utils';

export const useMoveToScreens = () => {
  const { openDeeplink } = useOpenDeeplink();

  return useCallback(
    (screenName: string) => {
      const link = buildUrl('ably://screens');
      appendParams(link, 'screen_name', screenName);
      openDeeplink(finalizeUrl(link));
    },
    [openDeeplink],
  );
};
